import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import NoImage from "../../assets/images/noimage.png";
import "./GuarantiesCheckCode.scss";
import "./Responsive.scss";

const GuarantiesCheckCode = () => {
    const [recaptch, setRecaptcha] = useState("");
    const breadCrumbData = [
        { title: "خانه", link: "/" },
        { title: "وضعیت گارانتی", link: "/guarantiesCheckCode" },
    ];
    const recaptchHandler = (recaptchaValue) => {
        setRecaptcha(recaptchaValue);
    };
    return (
        <section className="guarantieCheckWrapper mobile">
            <BreadCrumb breadCrumbData={breadCrumbData} />
            <div className="guarantieContent">
                <div className="desktop">
                    <div className="guarantieForm">
                        <div className="formHeader">
                            <p className="title">وضعیت گارانتی</p>
                        </div>
                        <div className="formWrapper">
                            <div className="formGroup">
                                <div className="guarantieImageFigure">
                                    <img src={NoImage} alt="no image" className="guarantieImage" />
                                </div>
                            </div>
                            <div className="formGroup">
                                <div className="caption">
                                    <input type="text" name="" id="name" placeholder="" />
                                    <span className="placeholder">کد گارانتی *</span>
                                </div>
                            </div>
                            <div className="formGroup">
                                <ReCAPTCHA size="invisible" sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt" onChange={recaptchHandler} />
                            </div>
                            <div className="formGroup">
                                <button type="submit" className="btnSend">بررسی</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default React.memo(GuarantiesCheckCode);
